export default "__VITE_ASSET__Bze0LGIf__"